
import { Component, Prop, Vue } from 'vue-property-decorator'
import Icon from '~/components/common/icon/Icon.vue'

@Component({
  name: 'IconInShape',
  components: {
    Icon
  }
})
export default class IconInShape extends Vue {
  @Prop({ type: String, default: 'div' }) type!: string
  @Prop({ type: String }) shapeType!: string
  @Prop({ type: String, required: true }) shapeSize!: string
  @Prop({ type: String }) shapeColor!: string
  @Prop({ type: String, default: '' }) iconName!: string
  @Prop({ type: String, default: '13px' }) iconSize!: string
  @Prop({ type: String }) iconColor!: string
  @Prop({ type: String }) iconFill!: string
  @Prop({ type: String }) iconStroke!: string

  get className() {
    if (this.shapeType === 'circle') { return 'rounded-circle' }
  }
}
